var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#F3EDF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3802 20.57L31.1502 22.42C31.7433 23.6031 32.0337 24.9148 31.9954 26.2377C31.957 27.5606 31.591 28.8533 30.9302 30H17.0702C16.2113 28.5101 15.8555 26.7831 16.0553 25.0751C16.2552 23.367 17.0001 21.7688 18.1797 20.5174C19.3592 19.266 20.9106 18.428 22.6039 18.1277C24.2972 17.8273 26.0422 18.0806 27.5802 18.85L29.4302 17.62C27.5467 16.4122 25.3125 15.871 23.0851 16.0829C20.8576 16.2949 18.7656 17.2477 17.1437 18.789C15.5217 20.3303 14.4635 22.3711 14.1384 24.5848C13.8132 26.7986 14.2399 29.0574 15.3502 31C15.5247 31.3023 15.7753 31.5536 16.077 31.7291C16.3787 31.9045 16.7211 31.9979 17.0702 32H30.9202C31.2726 32.0014 31.6191 31.9096 31.9247 31.734C32.2302 31.5584 32.484 31.3052 32.6602 31C33.5815 29.4039 34.0439 27.5843 33.9963 25.742C33.9486 23.8996 33.3928 22.1063 32.3902 20.56L32.3802 20.57Z",
    fill: "#A857F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5905 27.41C22.7762 27.596 22.9968 27.7435 23.2396 27.8442C23.4824 27.9448 23.7426 27.9966 24.0055 27.9966C24.2683 27.9966 24.5286 27.9448 24.7714 27.8442C25.0142 27.7435 25.2347 27.596 25.4205 27.41L31.0805 18.92L22.5905 24.58C22.4045 24.7658 22.257 24.9864 22.1564 25.2292C22.0557 25.472 22.0039 25.7322 22.0039 25.995C22.0039 26.2579 22.0557 26.5181 22.1564 26.7609C22.257 27.0037 22.4045 27.2243 22.5905 27.41Z",
    fill: "#A857F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.635c2885511696335aab4498398df8bf.svg";
export { ForwardRef as ReactComponent };